export enum CaseType {
  Surgery = 0,
  Orthodontics = 1
}
